export default "__VITE_ASSET__DNWl5RuC__"